export const zipCodesLabel = 'Zip codes';
export const editZipCodes = 'Edit zip codes';
export const regionsLabel = 'Technicians regions';
export const addRegionLabel = 'Add a region';
export const addRegionPlaceholder = 'Add a region...';
export const updateUserSuccess = (message) => `Successfully updated technician: ${message}!`;
export const errorUpdatingUser = (message) => `Error updating technician: ${message}`;
